import { CSSProperties } from "react";

import RepeatIcon from "@uui/Repeat01";

import { SxProps, Tooltip, Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import { lightOrDark } from "@app/embedded/theme/utils";

import { Row } from "@rui/Stack";

const Chip = styled(Row)(({ theme }) => ({
  color: theme.palette.shades.primary[500],
  backgroundColor: lightOrDark(
    theme.palette.shades.primary[50],
    theme.palette.shades.neutral[800]
  )(theme),
  borderRadius: theme.corners.small,
  padding: theme.spacing(0.5),
}));

const RecurringMeetingBadge = ({
  count = 0,
  size = "14px",
  sx,
}: {
  count?: number;
  size?: CSSProperties["height"];
  sx?: SxProps;
}) => (
  <Tooltip title="Recurring meeting" arrow>
    <Chip variant="center" sx={sx}>
      <Row
        spacing="2px"
        sx={{
          "& svg": {
            color: (theme) =>
              lightOrDark("shades.primary.500", "shades.primary.400")(theme),
          },
        }}
      >
        <RepeatIcon sx={{ height: size, width: size }} />
      </Row>
      {count > 0 && <Typography variant="labelMed">{count}</Typography>}
    </Chip>
  </Tooltip>
);

export default RecurringMeetingBadge;
